import { useState, useMemo } from 'react';
import ShopLayout from '../components/ShopLayout';
import DealCard from '../components/DealCard';
import { BUSINESS, BUSINESS_CATEGORIES } from '../data/business';

export default function BusinessPage() {
  const [search, setSearch] = useState('');
  const [category, setCategory] = useState('All');

  const filtered = useMemo(() => {
    const q = search.toLowerCase();
    return BUSINESS.filter(b => {
      const matchCat = category === 'All' || b.category === category;
      const matchSearch = !q || b.name.toLowerCase().includes(q) || b.package?.toLowerCase().includes(q);
      return matchCat && matchSearch;
    });
  }, [search, category]);

  return (
    <ShopLayout
      title="Business Solutions"
      subtitle="Enterprise-grade connectivity, RED BUSINESS plans and premium devices for your team."
      search={search}
      onSearch={setSearch}
      filters={BUSINESS_CATEGORIES}
      activeFilter={category}
      onFilter={setCategory}
    >
      {filtered.length === 0
        ? <p className="shop-empty">No deals match your search.</p>
        : filtered.map(b => <DealCard key={b.id} deal={b} type="business" />)
      }
    </ShopLayout>
  );
}
